import React, { createContext, useState, useEffect } from 'react';
import AuthService from 'services/auth-service';

export const ProfileContext = createContext();

export const ProfileProvider = ({ children }) => {
  const [profileImage, setProfileImage] = useState({
    image: '',
    purpose: 'profile'
  });

  const [images, setImages] = useState([]);
  const [galleryData, setGalleryData] = useState([]);
  const [error, setError] = useState(null);
  const [tabValue, setTabValue] = useState(0);
  const [notification, setNotification] = useState(false);
  const [biography, setBiography] = useState("");
  const [isEditFormVisible, setIsEditFormVisible] = useState(false);

  const [profileUserImage, setProfileUserImage] = useState({
    image: '',
    purpose: 'profile'
  });

  const [selectedUser, setSelectedUser] = useState({
    name: "",
    last_name: "",
    artist_name: "",
    email: "",
    city: "",
    street: "",
    state: "",
    country: "",
    postal_code: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [user, setUser] = useState({
    name: "",
    last_name: "",
    artist_name: "",
    email: "",
    is_visible: true,
    city: "",
    street: "",
    state: "",
    country: "",
    postal_code: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [selectedBiography, setSelectedBiography] = useState("");

  const [profileUser, setProfileUser] = useState({
    profile_name: "",
    profile_artist_name: "",
  });

  const [contacts, setContacts] = useState({
    phone1: "",
    site: "",
    tiktok: "",
    twitter: "",
    instagram: "",
  });


  // -------------------------
  // BUSCA DADOS DO USUÁRIO
  // -------------------------
  const getUserData = async () => {
    try {
      const response = await AuthService.getProfile();

      setUser({
        name: response.name ?? "",
        last_name: response.last_name ?? "",
        artist_name: response.artist_name ?? "",
        email: response.email ?? "",
        city: response.address?.city ?? "",
        address: response.address?.address ?? "",
        state: response.address?.state ?? "",
        country: response.address?.country ?? "",
        postal_code: response.address?.postal_code ?? "",
        is_visible: response.is_visible ?? true,
        newPassword: "",
        confirmPassword: ""
      });

      setProfileUser({
        profile_artist_name: response.artist_name,
        profile_name: response.name,
      });

      setContacts({
        phone1: response.contacts?.phone1 ?? "",
        site: response.contacts?.site ?? "",
        tiktok: response.contacts?.tiktok ?? "",
        twitter: response.contacts?.twitter ?? "",
        instagram: response.contacts?.instagram ?? ""
      });

      setBiography(response.biographies?.bio_text ?? "");

      if (response.profileMedia?.url) {
        setProfileImage({
          image: response.profileMedia.url,
          purpose: "profile",
        });
      } else {
        setProfileImage({
          image: "",
          purpose: "profile",
        });
      }

      if (Array.isArray(response.galleryMedia)) {
        setGalleryData(
          response.galleryMedia.map((img) => ({
            id: img.id,
            url: img.url,
          }))
        );
      } else {
        setGalleryData([]);
      }

    } catch (error) {
      console.error("Failed to fetch user data:", error);
    }
  };

  useEffect(() => {
    getUserData();
  }, []);

  const changeHandle = (state, setState) => (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <ProfileContext.Provider value={{
      profileImage, setProfileImage,
      images, setImages,
      galleryData, setGalleryData,
      error, setError,
      tabValue, setTabValue,
      notification, setNotification,
      user, setUser,
      biography, setBiography,
      profileUser, setProfileUser,
      contacts, setContacts,
      changeHandle,
    }}>
      {children}
    </ProfileContext.Provider>
  );
};
